import { toast } from "sonner";

export type FeedbackToastVariant = "green" | "blue" | "red" | "yellow";

const VARIANT_STYLES: Record<
  FeedbackToastVariant,
  { border: string; background: string }
> = {
  green: { border: "1px solid #99C2AC", background: "#EEF6F1" },
  blue: { border: "1px solid #CDD6EC", background: "#E8F0FB" },
  red: { border: "1px solid #F3DADA", background: "#FFEBEA" },
  yellow: { border: "1px solid #FEF7C2", background: "#FDFCEC" },
};

type FeedbackToastContentProps = {
  variant: FeedbackToastVariant;
  title: string;
  description?: string;
  boldText?: string;
};

function FeedbackToastContent({
  variant,
  title,
  description,
  boldText,
}: FeedbackToastContentProps) {
  const { border, background } = VARIANT_STYLES[variant];

  const renderDescription = () => {
    if (!description) return null;

    if (!boldText || !description.includes(boldText)) {
      return (
        <p
          style={{
            margin: 0,
            color: "#333",
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "20px",
          }}
        >
          {description}
        </p>
      );
    }

    const idx = description.indexOf(boldText);
    const before = description.slice(0, idx);
    const after = description.slice(idx + boldText.length);
    return (
      <p
        style={{
          margin: 0,
          color: "#333",
          fontSize: "14px",
          fontWeight: 400,
          lineHeight: "20px",
        }}
      >
        {before}
        <strong style={{ fontWeight: 700 }}>{boldText}</strong>
        {after}
      </p>
    );
  };

  return (
    <div
      style={{
        borderRadius: "16px",
        border,
        background,
        width: "328px",
        minWidth: "328px",
        padding: "16px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "2px",
          flex: 1,
        }}
      >
        <p
          style={{
            margin: 0,
            color: "#000",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "24px",
          }}
        >
          {title}
        </p>
        {renderDescription()}
      </div>
    </div>
  );
}

export type ShowFeedbackToastOptions = {
  variant?: FeedbackToastVariant;
  title: string;
  description?: string;
  boldText?: string;
  duration?: number;
};

export function showFeedbackToast({
  variant = "green",
  title,
  description,
  boldText,
  duration = 7000,
}: ShowFeedbackToastOptions) {
  toast.custom(
    (_id) => (
      <FeedbackToastContent
        variant={variant}
        title={title}
        description={description}
        boldText={boldText}
      />
    ),
    { duration },
  );
}
